import {
  useMonthlyMomentActions,
  type MonthlyMomentKind
} from './useMonthlyMomentActions';

export { useMonthlyMomentActions, type MonthlyMomentKind };

export function useMonthlyKeyDateActions() {
  return useMonthlyMomentActions('key-date');
}

export function useMonthlyEventActions() {
  return useMonthlyMomentActions('event');
}
